import { FormControlLabel, Switch, switchClasses } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { Dispatch, SetStateAction } from 'react';
import { PRIMARY_BLUE, GREY, WHITE } from '../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export interface ValidationSwitchProps {
  showProblems: boolean;
  setShowProblems?: Dispatch<SetStateAction<boolean>>;
}

const useStyles = makeStyles({
  validationSwitchRoot: {
    height: 26,
    padding: 0,
    margin: 10,
  },
  validationSwitchSwitchBase: {
    padding: 1,
    [`& .${switchClasses['checked']}`]: {
      transform: 'translateX(16px)',
      color: WHITE,
      '& + $track': {
        backgroundColor: PRIMARY_BLUE,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: PRIMARY_BLUE,
      border: 'none',
    },
  },
  validationSwitchThumb: {
    width: 24,
    height: 24,
  },
  validationSwitchTrack: {
    borderRadius: 26 / 2,
    border: `1px solid ${GREY}`,
    backgroundColor: GREY,
    opacity: 1,
  },
});

export const ValidationSwitch = ({ showProblems, setShowProblems }: ValidationSwitchProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <span>
      <FormControlLabel
        control={<Switch checked={showProblems} onChange={() => setShowProblems!(!showProblems)} />}
        label={t('import.rowsWithErrors') as string}
        classes={{
          root: classes.validationSwitchRoot,
          labelPlacementStart: classes.validationSwitchSwitchBase,
        }}
      />
    </span>
  );
};
